import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";
import anim_line from "../../img/winter.png"
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";

import LoadingButton from "../../Loading/LoadingButton";
import { useSelector } from "react-redux";
import {Activity, ChevronLeft, ChevronRight, CircleMinus, CirclePlus, Minus, Plus, X } from 'lucide-react';
import Snackbar from "../../../Snackbar";
import { createCourseByAdminV2, createPricePlanByAdmin, getAPricePlanByProductId } from "../../../store/actions/CreateCourse/createCourseByAdmin";
import AppMenuCardBlueBG from "../AppCards/AppMenuCardBlueBG";
import NextStepCardPopUp from "../AppCards/NextStepCardPopUp";
import AppMenuCardBlueBGTwo from "../AppCards/AppMenuCardBlueBGTwo";
import { DayPicker } from "react-day-picker";
import Toggle from "../../UI/Toggle";
import SkillsProductAddMore from "../CreateProduct/SkillsProductAddMore";
import InstallmentPlanAddMore from "./InstallmentPlanAddMore";
const ExpiryAndPrivacy = ({setActiveCardOverview,baseUrl,producttype})=>{

  const history = useHistory();
   const dispatch = useDispatch();

   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
  const [goNextPopUp, setGoNextPopUp] =useState(false);
 
 const [activeStep, setActiveStep] = useState(0);
 const [activeSubStepOne, setActiveSubStepOne] = useState(3);
 
 const [activeSubStepTwo, setActiveSubStepTwo] = useState(3);
 const [activeSubStepThree, setActiveSubStepThree] = useState(0);
 const [activeSubStepFour, setActiveSubStepFour] = useState(0);
 const [activeSubStepFive, setActiveSubStepFive] = useState(0);
 
const steps = ([{number:1,name:"Price"},{number:2,name:"Expiry & Privacy"},{number:3,name:"Upsale & Coupons"}]);
const subSteps = [1, 2, 3, 4, 5];
const subStepOneTotal= 3;
const subStepTwoTotal= 3;
const subStepThreeTotal= 3;
const subStepFourTotal= 8;
const subStepFiveTotal= 1;
;
 const showSnackbar = () => {
   setSnackbarVisible(true);
 };

 const hideSnackbar = () => {
   setSnackbarVisible(false);
 };
 const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
  {
    
    dispatch({type: "CURSOR",payload:true  });

    dispatch({type: "CURSORTEXT",payload:CursorText})
    dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
    dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
  }
   
  const handleMouseLeave = () => {
    
    dispatch({type: "CURSOR",payload:false})

    dispatch({type: "CURSORTEXT",payload:""})

    dispatch({type: "CURSORTEXTBG",payload:""})
    dispatch({type: "CURSORTEXTCOLOR",payload:""})
  

}
  
 const currentToken = useSelector((state)=>state?.user?.user?.token);
 const user_email = useSelector((state)=>state?.user?.user?.user_email
);

const courseData = useSelector((state)=>state?.course?.course);
const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
const appId = useSelector((state)=>state?.app?.app?.ID);
const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);

const [loader , setLoader] =useState({status:false});
const [loaderPriceType , setLoaderPriceType] =useState({status:false});
  const [pricePlan, setPricePlanObject] = useState("");
 const [editType, setEditType] = useState(courseData?.ID?"productName":"");
 const [pricePlanTypeStatus, setPricePlanTypeStatus] = useState(false);

 const [pricePlanType, setPricePlanType] = useState();
 const [productValidityType, setProductValidityType] = useState();
 const [discountPriceWeb, setDiscountPriceWeb] = useState();
 const [effectivePriceWeb, setEffectivePriceWeb] = useState();
 const [discountStatusWeb, setDiscountStatusWeb] = useState();
 const [regularPriceAndroid, setRegularPriceAndroid] = useState();
 const [discountPriceAndroid, setDiscountPriceAndroid] = useState();
 const [effectivePriceAndroid, setEffectivePriceAndroid] = useState();
 const [discountStatusAndroid, setDiscountStatusAndroid] = useState();
 const [regularPriceiOS, setRegularPriceiOS] = useState();
 const [discountPriceiOS, setDiscountPriceiOS] = useState();
 const [effectivePriceiOS, setEffectivePriceiOS] = useState();
 const [discountStatusiOS, setDiscountStatusiOS] = useState();
 const [expiryStartDate, setExpiryStartDate] = useState();
 const [setDiscountScheduleStatus, updateDiscountScheduleStatus] = useState();
 const [platformWeb, setPlatformWeb] = useState();
 const [platformAndroid, setPlatformAndroid] = useState();
 const [platformiOS, setPlatformiOS] = useState();
 
 const [setPricesDiffferentlyForRenewalUsers, updateSetPricesDiffferentlyForRenewalUsers] = useState();

 const [regularPriceRenewalUsers, setRegularPriceRenewalUsers] = useState();
 const [discountPriceRenewalUsers, setDiscountPriceRenewalUsers] = useState();
 const [effectivePriceRenewalUsers, setEffectivePriceRenewalUsers] = useState();
 const [discountStatusRenewalUsers, setDiscountStatusRenewalUsers] = useState();
 const [addDiffPricesForRenewalUsersPopUp, setAddDiffPricesForRenewalUsersPopUp] = useState();
 const [setPricesDiffferentlyForPlatforms, updateSetPricesDiffferentlyForPlatforms] = useState();
 const [allowInstallmentPrices, updateAllowInstallmentPrices] = useState();
 const [addDiffPricesForDevicesPopUp, setAddDiffPricesForDevicesPopUp] = useState();
 
 let TypeTitle= courseData?.ID?courseData?.type=='course'?"Course":
  courseData?.type=='batch'?"Batch":
  courseData?.type=="testSeries"?"Test Series":
  courseData?.type=="homeTutor"?"Home Tutor Offering":
  courseData?.type=="bundle"?"Bundle":
courseData?.type=="digitalProduct"?"Digital Product":"Course":"Course";
 const [animate, setAnimate] = useState(false);

   const [totalNo, setTotalNo] = useState();
     
   const [durationTypeVal, setDurationTypeVal] = useState();

   const changetotalNumber = ( totalNumber) => {
    // const validityValue= { validityCount:totalNumber,
    //    validityDurationType:itemArr?.validityValue?.validityDurationType}
    
    setTotalNo(totalNumber);
            handleCreatePricePlan("durationValue",{validityCount:totalNumber,durationType:durationTypeVal})
   };
   
   const changeDurationType = ( durationType) => {
    
    //  const validityValue= { expiryDate:"",validityCount:itemArr?.validityValue?.validityCount,
    //    validityDurationType:durationType,lifeTimeValidity:true}
     
    setDurationTypeVal(durationType);
        handleCreatePricePlan("durationValue",{validityCount:totalNo,durationType:durationType})
   };
  
   useEffect(() => {
    setTotalNo(courseData?.trialdurationValue?JSON.parse(courseData?.trialdurationValue)?.validityCount:5)
         setDurationTypeVal(courseData?.trialdurationValue?JSON.parse(courseData?.trialdurationValue)?.validityDurationType:"days");
          // Trigger the animation after a delay (e.g., 500ms)
           // Cleanup on unmount
        }, []);
     useEffect(() => {
      
          
  
     }, []);
    
    
   
    

 useEffect(() => {
   // Trigger the animation after a delay (e.g., 500ms)
   const timer = setTimeout(() => {
    setAnimate(true);  
  }, 100);

   return () => clearTimeout(timer); // Cleanup on unmount
 }, []);
useEffect(()=>{
  setActiveCardOverview(true);
  fireGetAPricePlanByProductId()
},[])

const fireGetAPricePlanByProductId=()=>{

 let  sendObject= {productIds:courseData?.ID,type:"pricePlan",visibility:"public",orderBy:"ASC",
      userEmail:user_email?user_email:"",
       currentToken:currentToken?currentToken:"",
       appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
 
  
  setLoader({status:true});
  
    const apiData = dispatch(getAPricePlanByProductId(sendObject));
    /* get response as Promise   */
    apiData.then(response => {
      if(response){
        
        setPricePlanTypeStatus(true)
        console.log(response);
        if(response?.pricePlan){
      setResponseMessage(response?.message);
      setSnackbarColor("rgba(144, 202, 249,1)");
    
       
  setLoader({status:false});
  setAnimate(false); 
  // setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
    setTotalNo(response?.pricePlan?.durationValue?JSON.parse(response?.pricePlan?.durationValue)?.validityCount:5);
    setDurationTypeVal(response?.pricePlan?.durationValue?JSON.parse(response?.pricePlan?.durationValue)?.durationType:"")
     setPricePlanType(response?.pricePlan?.pricePlanType)
    setPricePlanObject(response?.pricePlan);
    setProductValidityType(response?.pricePlan?.productValidityType?response?.pricePlan?.productValidityType:"")
    // setRegularPriceWeb(response?.pricePlan?.regularPriceWeb)
    // setDiscountPriceWeb(response?.pricePlan?.discountPriceWeb)
    // setEffectivePriceWeb(response?.pricePlan?.effectivePriceWeb)
    //  setRegularPriceAndroid(response?.pricePlan?.regularPriceAndroid)
    // setDiscountPriceAndroid(response?.pricePlan?.discountPriceAndroid)
    // setEffectivePriceAndroid(response?.pricePlan?.effectivePriceAndroid)
    // setRegularPriceiOS(response?.pricePlan?.regularPriceiOS)
    // setDiscountPriceiOS(response?.pricePlan?.discountPriceiOS)
    // setEffectivePriceiOS(response?.pricePlan?.effectivePriceiOS)
    // setRegularPriceRenewalUsers(response?.pricePlan?.regularPriceRenewalUsers)
    // setDiscountPriceRenewalUsers(response?.pricePlan?.discountPriceRenewalUsers)
    // setEffectivePriceRenewalUsers(response?.pricePlan?.effectivePriceRenewalUsers)
    setExpiryStartDate(response?.pricePlan?.expiryStartDate)
    setSelectedDate(response?.pricePlan?.expiryStartDate?JSON.parse(response?.pricePlan?.expiryStartDate)?.selected:"");
    setSelected(formatDateString(response?.pricePlan?.expiryStartDate?JSON.parse(response?.pricePlan?.expiryStartDate)?.selected:""));
    // updateDiscountScheduleStatus(JSON.parse(response?.pricePlan?.setDiscountScheduleStatus))
    // setPlatformWeb(JSON.parse(response?.pricePlan?.platformWeb))
    // setPlatformAndroid(JSON.parse(response?.pricePlan?.platformAndroid))
    // setPlatformiOS(JSON.parse(response?.pricePlan?.platformiOS))
    // updateSetPricesDiffferentlyForPlatforms(JSON.parse(response?.pricePlan?.setPricesDiffferentlyForPlatforms))
    // updateSetPricesDiffferentlyForRenewalUsers(JSON.parse(response?.pricePlan?.setPricesDiffferentlyForRenewalUsers))
    // updateAllowInstallmentPrices(JSON.parse(response?.pricePlan?.allowInstallmentPrices))
    // setItemArr(response?.pricePlan?.installmentValues?JSON.parse(response?.pricePlan?.installmentValues):[{ no:1, id: generateTimestamp()+1
    //   ,value:{amount:100,validityCount:3,validityDurationType:"days"} },{ no:2, id: generateTimestamp()+2
    //       ,value:{amount:2000,validityCount:1,validityDurationType:"months"} },])
     setAnimate(true);  
  },1000)

     }else{
          
      setResponseMessage(response?.message);
      setSnackbarColor("rgba(144, 202, 249,1)");
    
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
     }
        
     
     if(response?.logout){
     
      setResponseMessage("You are Logged Out!!!");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      setTimeout(()=>{
        dispatch({type:"LOGOUT"});
  
      },3000)
      
    }
  /* resetting Login input Fields */
  
      }else{
        setResponseMessage("Something Went Wrong...");
        
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)    }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      console.error(error);
    });
   
    }


  const handleCreatePricePlan=(editType,sendDataValue)=>{
  let sendObject;
  setAnimate(false); 
  if(editType=="productValidityType"){
    setLoader({...loader,statusProductValidityType:true,status:true});
    sendObject= {productValidityType:sendDataValue,productIds:courseData?.ID,type:"pricePlan",
       userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:editType,postId:pricePlan?.ID?pricePlan?.ID:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }if(editType=="expiryStartDate"){
    setLoader({...loader,status:true});
    sendObject= {expiryStartDate:JSON.stringify(sendDataValue),productIds:courseData?.ID,type:"pricePlan",
       userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:editType,postId:pricePlan?.ID?pricePlan?.ID:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }
   if(editType=="durationValue"){
    setLoader({...loader,statusDurationValue:true,status:true});
    sendObject= {durationValue:JSON.stringify(sendDataValue),productIds:courseData?.ID,type:"pricePlan",
       userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:editType,postId:pricePlan?.ID?pricePlan?.ID:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }
   
    const apiData = dispatch(createPricePlanByAdmin(sendObject));
    /* get response as Promise   */
    apiData.then(response => {
      if(response){console.log(response);
        if(response?.pricePlan){
          if(editType!="productValidityType"&&editType!="expiryStartDate"&&editType!="durationValue"){
            setResponseMessage(response?.message);
            setSnackbarColor("rgba(144, 202, 249,1)");
          
  setSnackbarVisible(true);
          }
                
          setLoader({...loader,statusProductValidityType:false,statusDurationValue:false,status:false});
           
  setTimeout(()=>{
   
    
    setSnackbarVisible(false);
   
    setPricePlanObject(response?.pricePlan);
    setProductValidityType(response?.pricePlan?.productValidityType?response?.pricePlan?.productValidityType:"")
    setTotalNo(response?.pricePlan?.durationValue?JSON.parse(response?.pricePlan?.durationValue)?.validityCount:5);
    setDurationTypeVal(response?.pricePlan?.durationValue?JSON.parse(response?.pricePlan?.durationValue)?.durationType:"")
    setAnimate(true); 
  },1000)
     }else{
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
     }
        
     
     if(response?.logout){
     
      setResponseMessage("You are Logged Out!!!");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      setTimeout(()=>{
        dispatch({type:"LOGOUT"});
  
      },3000)
      
    }
  /* resetting Login input Fields */
  
      }else{
        setResponseMessage("Something Went Wrong...");
        
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)    }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      console.error(error);
    });
   
    }
    

    const [selected, setSelected] = useState(null);


       const [selectedDate, setSelectedDate] = useState(null);
            const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
            const [startYear, setStartYear] = useState(2020);
            const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
            const [statusYear,setStatusYear]=useState(false)
            const [statusMonth,setStatusMonth]=useState(false)
            const [statusCalendar,setStatusCalendar]=useState(true)
            const [startDate,setStartDate]=useState("")
            const [endDate,setEndDate]=useState("")
            
            function getYearAndMonth(dateString) {
              // Split the input string by the '-' delimiter
              const [day, month, year] = dateString.split('-');
          
              // Return an object containing the year and month
              return {
                  year: parseInt(year, 10),
                  month: parseInt(month, 10)
              };
          }
          
         
const modifiers = {
    weekend: { dayOfWeek: [0, 6] },  // Highlight weekends
    // holiday: [new Date(2024, 11, 25), new Date(2024, 0, 1)] ,

    //   start: selected?.from,       // Modifier for the start date
    //     end: selected?.to 
  };
  
  const modifiersStyles = {
    weekend: {   borderRadius:"50%",background:"#f1f1f1"},
    // holiday: { color: "red", backgroundColor: "yellow" },
    selected:{ backgroundColor: "rgba(149, 143, 218,0.11)", },
    start: { color: "#fff" , backgroundColor: "rgba(149, 143, 218,1)",borderRadius:"50%"},       // Class for the start date
        end: { color: "#fff" , backgroundColor: "rgba(149, 143, 218,1)",borderRadius:"50%"}
  };
 
 useEffect(() => {
     
     
     if(pricePlan?.expiryStartDate?.date){
      // const date = new Date(courseData?.CourseDuration?.validityValue?.expiryDate?.date);
       // Example usage
    const date = pricePlan?.expiryStartDate?.date;
    const result = getYearAndMonth(date);
   setSelectedMonth(result?.month-1);
  setSelectedYear(result?.year);
     } 
       // Trigger the animation after a delay (e.g., 500ms)
       const timer = setTimeout(() => {
        setAnimate(true);  
      }, 100);
    
       return () => clearTimeout(timer); // Cleanup on unmount
     }, [pricePlan?.ID]);
    
    
  const handleDayClick = (day) => {
     // alert(`You clicked ${date.toDateString()}`);
    //  console.log(formatDateString(day))
setSelected(formatDateString(day));
handleCreatePricePlan("expiryStartDate",{selected:day,from:formatDateString(day?.from),to:formatDateString(day?.to)});

    //  console.log({selected:day,date:formatDateString(day)})
   
  };
  function formatDateString(dateString) {
  // Parse the date string into a Date object
  const date = new Date(dateString);
  
  // Extract day, month, and year
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();
  
  // Format as "DD-MM-YYYY"
  return `${day}-${month}-${year}`;
}










  const handlePrevious = () => {
    setStartYear((prev) => Math.max(1900, prev - 10));
  };

  const handleNext = () => {
    setStartYear((prev) => Math.min(2100 - 9, prev + 10));
   
  };

  const handleSelectMonth = (month) => {
    setSelectedMonth(month);setStatusMonth(false)
    setStatusCalendar(true)
  };
  function YearGrid({ startYear, onSelectYear, selectedYear, onPrevious, onNext }) {
    const years = Array.from({ length: 10 }, (_, i) => startYear + i);
  
    return (
      <div style={{width:"320px",marginBottom: "10px" ,marginTop: "10px"}}>
        <div style={{ display: "flex",
             justifyContent: "space-between" , padding:"10px",background:"#fff",padding:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",borderRadius: "15px",marginBottom: "10px" ,marginTop: "10px"}}>
       
    <div  onClick={()=>{setStatusYear(false)
        setStatusMonth(false);
    setStatusCalendar(true)}} style={{ color: "#fff" ,cursor:"pointer",width:"30px",height:"30px", border: "2px solid rgba(149, 143, 218,1)",borderRadius:"50%",}} 
    ><ChevronLeft style={{marginRight:"1px"}}  color="rgba(149, 143, 218,1)" size={30}/> </div>
     
     <button style={{  fontSize:"14px",padding:"6px",textAlign:"center",cursor:"pointer",width:"80px",
         border: `${startYear <= 1900
            ?"2px solid rgba(149, 143, 218,0.41)":"2px solid rgba(149, 143, 218,1)"}`,borderRadius:"10px",}} 
         onClick={onPrevious} disabled={startYear <= 1900}>
            Previous
          </button>
          <div style={{padding:"5px"}}>Select Year</div>
          <button  style={{ fontSize:"14px",padding:"6px",textAlign:"center",
            cursor:"pointer",width:"80px", border: 
            `${startYear + 25 > 2100
            ?"2px solid rgba(149, 143, 218,0.41)":"2px solid rgba(149, 143, 218,1)"}`
            ,borderRadius:"10px",}} onClick={onNext} disabled={startYear + 25 > 2100}>
            Next
          </button>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: "10px",background:"#fff",padding:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",borderRadius: "15px",}}>
          {years.map((year) => (
            <button
              key={year}
              onClick={() => {onSelectYear(year);
                setStatusYear(false) ;
                setStatusMonth(true)
                setStatusCalendar(false)
              }}
              style={{
                padding: "10px",height:"90px",
                backgroundColor: year === selectedYear ? "rgba(149, 143, 218,1)" : "#f0f0f0",
                color: year === selectedYear ? "white" : "black",
                borderRadius: "5px",
                border: "1px solid #ddd",
                cursor: "pointer"
              }}
            >
              {year}
            </button>
          ))}
        </div>
      </div>
    );
  }
  function MonthGrid({ onSelectMonth, selectedMonth }) {
    
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
  
    return (<>  <div style={{width:"320px",padding:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",borderRadius: "15px",background:"#fff" ,display: "flex", justifyContent: "space-between", marginBottom: "10px",marginTop: "10px"  }}>
       
        <div  onClick={()=>{setStatusYear(false)
            setStatusMonth(false);
        setStatusCalendar(true)}} 
        style={{ color: "#fff" ,cursor:"pointer",width:"30px",height:"30px", border: "2px solid rgba(149, 143, 218,1)",borderRadius:"50%",}} 
        ><ChevronLeft style={{marginRight:"1px"}}  color="rgba(149, 143, 218,1)" size={30}/> </div>
        
              <div style={{padding:"5px"}}>Select Month</div>
             <div style={{ fontSize:"14px",padding:"6px",textAlign:"center",cursor:"pointer",width:"100px", border: "2px solid rgba(149, 143, 218,1)",borderRadius:"10px",}}  onClick={()=>{setStatusYear(true)
        setStatusMonth(false);
    setStatusCalendar(false)}}> Change Year</div>
    
            </div> 
      <div style={{width:"320px", padding:"10px",display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "10px", marginBottom: "10px"
       ,boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",borderRadius: "15px",background:"#fff" }}>
        {months.map((month, index) => (
          <button
            key={month}
            onClick={() => onSelectMonth(index)}
            style={{
              padding: "10px",
              backgroundColor: index === selectedMonth ? "rgba(149, 143, 218,1)" : "#f0f0f0",
              color: index === selectedMonth ? "white" : "black",
              borderRadius: "5px",
              border: "1px solid #ddd",
              cursor: "pointer"
            }}
          >
            {month}
          </button>
        ))}
      </div>
      </>);
  }
   
    return <>
    
{<>
  {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}

<div  className="ikcraft_login-signup-card-outerj"><div  className=" contentPageScroller " style={{background:"#fff",borderRadius:"25px"}}>
 <div  className=" " >
   {/* <h2 style={{"textAlign":"center",paddingTop:"15px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px)',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}>  Now You Can Add Both Price And Membership Plans For <span className="coloredTextV1" > {TypeTitle}</span> </h2>
 <div className="gridFiftyFixed"style={{
       
      }}><div style={{  transform: animate ? 'scale(1)' : 'scale(.91)',
          opacity: animate ? 1 : 0.8,
          transition: 'transform 1s ease, opacity 1s ease',}}>
   <AppMenuCardBlueBG  activeCard={""} icon={5} title ="Add Price " onClickPopup={
            ()=>{ history.push(`${baseUrl}/price`) 
            }}  /></div>
  <div><AppMenuCardBlueBGTwo activeCard={""} icon={1} title ="Membership" onClickPopup={
          ()=>{ history.push(`${baseUrl}/membership-plan`)
          }}  /></div> 
          
   
   </div>  */}
       <div   className=" progress-bar-container "> 
   <div className="progress-bark">
        {steps?.map((step) => (<div className="animCirclek"  onMouseEnter={
                               ()=>handleMouseEnter("#fff","#333","")}
     onMouseLeave={handleMouseLeave}  onClick={()=>{
        if(step?.number==1){
            history.push(`${baseUrl}/price`)
          }else if(step?.number==2){
            history.push(`${baseUrl}/expiry`)
          }else if(step?.number==3){
            history.push(`${baseUrl}/upsale`)
          }
        }} style={{position:"relative"}} key={step?.number}>
          <div
            
            className={`circlek ${step?.number <= activeStep ? "activek" : ""}` }
            style={{background: `${step?.number ===1?
              `${activeSubStepOne?`conic-gradient(#565283 0% ${activeSubStepOne*100/subStepOneTotal}%, #ffffff 
                                                ${activeSubStepOne*100/subStepOneTotal}% 100%)`:""}`:
                                                step?.number ===2?
                                                `${activeSubStepTwo?`conic-gradient(#565283 0% 
                                                ${activeSubStepTwo*100/subStepTwoTotal}%, #ffffff 
                                                ${activeSubStepTwo*100/subStepTwoTotal}% 100%)`:""}`: 
                                                step?.number ===3?
                                                `${activeSubStepThree?`conic-gradient(#565283 0% 
                                                ${activeSubStepThree*100/subStepThreeTotal}%, #ffffff 
                                                ${activeSubStepThree*100/subStepThreeTotal}% 100%)`:""}`
                                                :step?.number ===4?
                                                `${activeSubStepFour?`conic-gradient(#565283 0% 
                                                ${activeSubStepFour*100/subStepFourTotal}%, #ffffff 
                                                ${activeSubStepFour*100/subStepFourTotal}% 100%)`:""}`:
                                                step?.number ===5?
                                                `${activeSubStepFive?`conic-gradient(#565283 0% 
                                                ${activeSubStepFive *100/subStepFiveTotal}%, #ffffff 
                                                ${activeSubStepFive*100/subStepFiveTotal}% 100%)`:""}`:""}
            `}} 
          ><div   className={`circlekInn `}>
             {step?.number}
          </div>
          <div align="center" style={{width:"110px",position:"absolute",top:"55px",fontSize:"14px"}}>{step?.name}</div>
          </div></div>
        ))}<div style={{width:"100%",height:"5px",background:"rgb(86, 82, 131)",position:"absolute",left:"0px",top:"25px",right:"0px"}}></div>
      </div>  
    
      </div><br/>
      {pricePlanTypeStatus?<div  style={{background:"rgba(144, 202, 249,0.1)",borderRadius:"25px",margin:"10px"}}>
   
 <div className="subCourseInfoInnerContainer"> 
 <div >  <h2 style={{"textAlign":"center",paddingTop:"15px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px)',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}>   Set Expiry Type For Your <span className="coloredTextV1" > {TypeTitle}</span>  </h2>
      </div>
      <div class="input-card-outer"style={{
            transform: animate ? 'translateY(0)' : 'translateY(10px)',
            opacity: animate ? 1 : 0.8,
            transition: 'transform 3s ease, opacity 3s ease',
          borderRadius:"25px",padding:"5px"}} >
                                    
                                    <div class=" gridForWhatsNextAfterYT3">
                                    <label onMouseEnter={
                               ()=>handleMouseEnter("#fff","#333","")}
     onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                       
                                          <div >{loader?.statusProductValidityType?"loading...":"Lifetime"}</div> 
                                       
                                                <input type="radio" title="lifetime"  

          checked={productValidityType=="lifetime"?"yes":""}
                                                 className="input-textbox"  value="lifetime"  name="coursePriceType"  
     onChange={e=>{
      
        handleCreatePricePlan("productValidityType",e.target.value)
        setProductValidityType(e.target.value);
   
    
    }

       
    }
    />
                                                   <span class={"boxCardBorder"}></span>
                                          </label>
                                          <label onMouseEnter={()=>
                       handleMouseEnter("#fff","#333","")}
     onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                       
                                       <div  >{loader?.statusProductValidityType?"loading...":"Set Duration"}</div> 
                                      
                                               <input  type="radio" title="duration"  
                                       checked={productValidityType=="duration"?"yes":""}         className="input-textbox"  value="duration" 
                                                 name="coursePriceType"  
                                                //  checked={freePaidStatus=="Paid"?true:false}
    onChange={e=>{
        handleCreatePricePlan("productValidityType",e.target.value);
        setProductValidityType(e.target.value);
      }
      
   }
   />
                                                  <span class={"boxCardBorder"}></span>
                                         </label>

                                         <label onMouseEnter={()=>
                       handleMouseEnter("#fff","#333","")}
     onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                       
                                       <div  >{loader?.statusProductValidityType?"loading...":"Set Expiry"}</div> 
                                      
                                               <input  type="radio" title="expiryDate"  
                                       checked={productValidityType=="expiryDate"?"yes":""}         className="input-textbox"  value="expiryDate" 
                                                 name="coursePriceType"  
                                                //  checked={freePaidStatus=="Paid"?true:false}
    onChange={e=>{
        handleCreatePricePlan("productValidityType",e.target.value);
        setProductValidityType(e.target.value);
      }
      
   }
   />
                                                  <span class={"boxCardBorder"}></span>
                                         </label>

                                  
    </div> </div>

  </div>
 

  </div>:""}
  {productValidityType=="expiryDate"?<div>
  
  <div  style={{background:"rgba(144, 202, 249,0.1)",borderRadius:"25px",margin:"5px",paddingBottom:"50px"}}>
        
        <div className=""> 
       
  <div style={{
        transform: animate ? 'translateY(0)' : 'translateY(10px)',marginBottom:"0px",
        opacity: animate ? 1 : 0.8,
        transition: 'transform 2s ease, opacity 2s ease',
      }}> <h2 style={{"textAlign":"center",paddingTop:"15px",
        transform: animate ? 'translateY(0)' : 'translateY(-10px)',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}>  Set Expiry Date Range  </h2> { <div  >
          <div style={{display:"flex",justifyContent:"center"}} ><div>
          {statusMonth?<MonthGrid onSelectMonth={handleSelectMonth} selectedMonth={selectedMonth} />
     :""} </div> </div>  <div style={{display:"flex",justifyContent:"center"}} > <div>
        
    {statusYear?<YearGrid
        startYear={startYear}
        onSelectYear={setSelectedYear}
        selectedYear={selectedYear}
        onPrevious={handlePrevious}
        onNext={handleNext}
      />  :""} </div> </div>{statusCalendar?<div><div style={{display:"flex",justifyContent:"center",}} > 
    <nav  style={{width:"320px",padding:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",borderRadius: "15px",background:"#fff" , display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "10px", marginBottom: "10px" ,marginTop: "10px" }} aria-label="">
      <div style={{ fontSize:"14px",padding:"6px",textAlign:"center",cursor:"pointer",width:"100px", border: "2px solid rgba(149, 143, 218,1)",borderRadius:"10px",}}  onClick={()=>{setStatusYear(true)
        setStatusMonth(false);
    setStatusCalendar(false)}}> Change Year</div>
      <div 
      style={{  fontSize:"14px",padding:"6px",textAlign:"center",cursor:"pointer",width:"100px", border: "2px solid rgba(149, 143, 218,1)",borderRadius:"10px",}}  onClick={()=>{setStatusYear(false)
        setStatusMonth(true);
    setStatusCalendar(false)}}>Change Month</div>
    
     <div  style={{ color: "#fff" ,cursor:"pointer",width:"30px",height:"30px", border: "2px solid rgba(149, 143, 218,1)",borderRadius:"50%",}} onClick={()=>{handleSelectMonth(selectedMonth-1)} } ><ChevronLeft style={{marginRight:"1px"}}  color="rgba(149, 143, 218,1)" size={30}/> </div>
     <div style={{ color: "#fff" ,cursor:"pointer",width:"30px",height:"30px", border: "2px solid rgba(149, 143, 218,1)",borderRadius:"50%",}} onClick={()=>{handleSelectMonth(selectedMonth+1)} } > <ChevronRight style={{marginLeft:"1px"}} color="rgba(149, 143, 218,1)" size={30}/></div>
      </nav></div>
      <div style={{display:"flex",justifyContent:"center",}}>
        
        <DayPicker 
           //   fromYear={1900}  // Start year for the dropdown
           //   toYear={2100}    // End year for the dropdown
           //   captionLayout="dropdown"  // Use dropdown layout for month and year
        
             numberOfMonths={2}
               mode="range"
               selected={selectedDate}
               onSelect={(date)=>{setSelectedDate(date)
                   setStartDate(formatDateString(date?.from));
         
                   setEndDate(formatDateString(date?.to))
                   handleDayClick(date)
                   
                }}
               month={new Date(selectedYear, selectedMonth)}// Show the selected year in the calendar
               modifiers={modifiers}
               labelsFormatters={{
                 formatWeekdayName: (day) => day.toLocaleDateString("es-ES", { weekday: "short" })
               }} 
               styles={{
                   caption: { color: "#99cc99" },
                   day: { borderRadius: "50%" },
                  
                 }}
               components={{
             Caption: ({ month }) => <strong>{month.toLocaleString('default', { month: 'long' })}</strong>,
             Footer: () => <p>Select your preferred date.</p>
         
           }}
           
           onDayClick={()=>{}}
            disabled={[
                 { before: new Date() }, // Disable past dates
                 // { dayOfWeek: [0] } // Disable weekends
               ]}
               modifiersStyles={modifiersStyles}
               // dayContentRenderer={(day) => (
               //   <div style={{ textAlign: 'center' }}>
               //     {day.getDate()}
               //     {day.getDay() === 0 && <span role="img" aria-label="holiday">🌟</span>} {}
               //   </div>
               // )}
               // showWeekNumber
          
           // footer={<p>End of Calendar</p>}
           // renderDay={(day) => (
           //   <div style={{ position: "relative" }}>
           //     <span>{day.getDate()}</span>
           //     {day.getDate() === 1 && <span style={{ color: "red" }}>Start</span>}
           //   </div>
           // )}
                /> </div> </div>:""}</div>}</div></div>
                </div>
                
             
             
             
             </div>:productValidityType=="duration"?
   <div className="subCourseInfoInnerContainer"> 
   <div >  <h2 style={{"textAlign":"center",paddingTop:"15px",
          transform: animate ? 'translateY(0)' : 'translateY(-10px)',
          opacity: animate ? 1 : 0.8,
          transition: 'transform 1s ease, opacity 1s ease',
        }}>   Set Duration For Your <span className="coloredTextV1" > {TypeTitle}</span> Access </h2>
        </div>
        <div  style={{"textAlign":"center",paddingTop:"15px",
          transform: animate ? 'translateY(0)' : 'translateY(-10px)',
          opacity: animate ? 1 : 0.8,
          transition: 'transform 1s ease, opacity 1s ease',
        }}>   <div style={{marginTop: '20px' ,gridTemplateColumns:  "15% 70% 15%" ,height:"80px" }}>
              {!loader?.statusDurationValue? <Minus  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}  onClick={()=>{setTotalNo(parseInt(totalNo)>1?parseInt(totalNo)-1:1)
                 changetotalNumber(parseInt(totalNo)>1?parseInt(totalNo)-1:1);
               }} style={{float:"left",background:"#555555 ",width:"35px",height:"35px",borderRadius:"50%",marginRight:"10px",
                     alignContent:"center",textAlign:"center",padding:"8px",cursor:"pointer"}} color="#fff" size={22}/>:<CircleMinus  onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave}  onClick={()=>{}} style={{float:"left",background:"#555555 ",width:"35px",height:"35px",borderRadius:"50%",marginRight:"10px",
                        alignContent:"center",textAlign:"center",padding:"8px",cursor:"pointer"}} color="#fff" size={22}/>}
                 <input onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}  value={parseInt(totalNo)} type="number"
                       onChange={(e)=>{changetotalNumber(e.target.value);setTotalNo(e.target.value);}}
                       style={{border:"2px dashed #555555  ",borderRadius:"10px",outline:0,float:"left",width:"55%",
                         padding:"10px",fontSize:"30px",color:"#555555 ",fontWeight:"bolder"}}
                   /> {!loader?.statusDurationValue? <Plus onMouseEnter={handleMouseEnter}
                   onMouseLeave={handleMouseLeave}  onClick={()=>{setTotalNo(parseInt(totalNo)+1)
                     changetotalNumber(parseInt(totalNo)+1);
                   }}  style={{float:"left",background:"#555555 ",width:"35px",height:"35px",borderRadius:"50%",marginLeft:"10px",
                     alignContent:"center",textAlign:"center",padding:"8px",cursor:"pointer"}}  color="#fff" size={22}/>:<CirclePlus onMouseEnter={handleMouseEnter}
                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }}  style={{float:"left",background:"#555555 ",width:"35px",height:"35px",borderRadius:"50%",marginLeft:"10px",
                       alignContent:"center",textAlign:"center",padding:"8px",cursor:"pointer"}}  color="#fff" size={22}/>}
                     
                     
                     
                     </div>  <div style={{height:"90px"}}> 
        <div class="input-card-outer"style={{
              transform: animate ? 'translateY(0)' : 'translateY(10px)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 3s ease, opacity 3s ease',
            borderRadius:"25px",padding:"5px"}} >
                                      
                                      <div class=" gridForWhatsNextAfterYT3">
                                              <label onMouseEnter={
                                         ()=>handleMouseEnter("#fff","#333","")}
                          onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                        <div >Years </div> 
                          <input type="radio" title="Set As Years"   checked={durationTypeVal=="years"?"yes":""}
               className="input-textbox"  value="years"  name="courseExpiryType1"  
               onClick={e=>{changeDurationType(e.target.value);;setDurationTypeVal(e.target.value);;}}/>
                    <span class={"boxCardBorder"}></span> </label>
                    <label onMouseEnter={
                                         ()=>handleMouseEnter("#fff","#333","")}
                          onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                        <div > Months </div> 
                          <input type="radio" title="Set As Months"   checked={durationTypeVal=="months"?"yes":""}
               className="input-textbox"  value="months"  name="courseExpiryType1"  
               onChange={e=>{changeDurationType(e.target.value);;setDurationTypeVal(e.target.value);;}}/>
                    <span class={"boxCardBorder"}></span> </label> <label onMouseEnter={
                                         ()=>handleMouseEnter("#fff","#333","")}
                          onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                        <div >Days </div> 
                          <input type="radio" title="Set As Days"   checked={durationTypeVal=="days"?"yes":""}
               className="input-textbox"  value="days"  name="courseExpiryType1"  
               onChange={e=>{changeDurationType(e.target.value);setDurationTypeVal(e.target.value);}}/>
                    <span class={"boxCardBorder"}></span> </label>
                    </div>  </div></div>   </div>                   
                                                </div>:""}
             
  <div style={{height:"110px"}}></div>
   <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
    <div  >   </div>
  
    
    <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
     id="signupBtn"> Back </button>

 <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{}} style={{width:"140px",height:"55px",padding:"15px 10px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
     id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Go To Set Upsale"} </button>
     
  </div>
  
    <div  className="ikcraft_login-input-card">
   
      
  </div>

  <div> 
    
    
    
    
  </div>
 </div>
    
 <div></div>
 {goNextPopUp?<NextStepCardPopUp loadingText="Going Next..."  title="Next Step> Create Mock Tests & Add Contents.   Let's Go Next" type="addAproxContent"
 closePopUp={()=>{setGoNextPopUp(false)}}
 onClickPopup={(type)=>{setTimeout(()=>{
  history.push(`${baseUrl}/approx-material`)
 },1000)
  }}/>:""}

  </div></div>
</>}
    </>

}

export default ExpiryAndPrivacy;

